import { EventBus } from "../../../eventbus";
import { userHasAllRights } from "../../../functions/userRights";
import i18n from "../../../functions/i18next";

export default {
  props: {
    mySpace: Number,

    defaultBtns: {
      type: Array,
      default: () => [],
    },
    selectedBtns: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedItems: 0,
    };
  },
  methods: {
    emit(emitterName, emitterData) {
      EventBus.$emit(emitterName, emitterData);
    },
    checkRights(rights, useMySpace, showOnMySpace) {
      return (
        userHasAllRights(rights, this) ||
        (useMySpace && this.mySpace ? showOnMySpace : false)
      );
    },
    countSelectedItems() {
      const transferItems = this.$store.state.transferItems;
      let count = 0;

      Object.keys(transferItems).forEach((key) => {
        count += Array.from(transferItems[key]).length;
      });

      this.selectedItems = count;
    },
  },
  computed: {
    hasSelectedItems() {
      this.countSelectedItems();

      return this.selectedItems > 0;
    },
    selectedItemCount() {
      this.countSelectedItems();

      return `${this.selectedItems} ${i18n.tc(
        "common.item",
        this.selectedItems
      )}`;
    },
  },
  watch: {
    "$store.state.transferItems": () => {},
  },
};
